/* ==========================================================================
   Orvo — radio.js
   Loaded only on the emergency radio template, after cut.js. cut.js runs the
   gallery, the tier selection, the sticky bar, accordions and reviews; this
   file adds the one thing the radio page has on top: the emergency bivy as a
   preselected add-on, and the cart lines that go with it.

   Cart writes go through window.OrvoAddToCart (theme.js), so the drawer,
   free-shipping meter and upsell popup are the same as everywhere else.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-rd-root]');
  if (!root) return;

  var STR = ((window.Orvo || {}).strings || {});
  var SAVE_FMT = STR.youSaveAtCheckout || STR.youSave || '%s';
  function int(v) { return parseInt(v, 10) || 0; }
  function money(cents) {
    if (window.OrvoMoney) return window.OrvoMoney(cents);
    var whole = String(Math.floor(Math.abs(cents) / 100)).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ');
    return (cents < 0 ? '-' : '') + whole + ' kr';
  }

  var mode = root.getAttribute('data-addon-mode') || 'none';
  var baseId = int(root.getAttribute('data-base-id'));
  var addonId = int(root.getAttribute('data-addon-id'));
  var addPrice = int(root.getAttribute('data-addon-price'));
  var addWas = int(root.getAttribute('data-addon-was'));
  // Each pack carries its own copy of the add-on row (only the selected
  // pack's is visible); they always share one state.
  var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-rd-addon-input]'));
  var labels = Array.prototype.slice.call(root.querySelectorAll('[data-rd-addon]'));
  var on = inputs.length ? inputs[0].checked : false;

  function addonOn() { return mode !== 'none' && inputs.length > 0 && on; }
  function currentBox() {
    return root.querySelector('[data-kp-tier].is-selected') || root.querySelector('[data-kp-tier="2"]') || root.querySelector('[data-kp-tier]');
  }

  // The button label and the saving line: the tier's total plus the bivy when ticked.
  // The [data-kp-total] node is looked up every time: theme.js rewrites the
  // button's HTML after an add, which replaces it.
  function paint() {
    var box = currentBox();
    if (!box) return;
    var withAddon = addonOn();
    var total = int(box.getAttribute('data-total')) + (withAddon ? addPrice : 0);
    var save = int(box.getAttribute('data-save')) + (withAddon ? Math.max(0, addWas - addPrice) : 0);
    var totalEl = root.querySelector('[data-kp-total]');
    if (totalEl) totalEl.textContent = money(total);
    var saveEl = root.querySelector('[data-kp-save]');
    if (saveEl) {
      if (save > 0) { saveEl.textContent = SAVE_FMT.replace('%s', money(save)); saveEl.hidden = false; }
      else saveEl.hidden = true;
    }
    inputs.forEach(function (i) { i.checked = on; });
    labels.forEach(function (l) { l.classList.toggle('is-on', withAddon); });
  }

  inputs.forEach(function (i) {
    i.addEventListener('change', function () { on = i.checked; paint(); });
  });
  // cut.js selects the tier in its own (earlier) listener; repaint right after it.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-kp-tier-head]') || e.target.closest('[data-kp-jump]')) setTimeout(paint, 0);
  });

  // ---- Add to cart ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rd-add]');
    if (!btn) return;
    e.preventDefault();
    var box = currentBox();
    if (!box || !baseId) return;
    var units = int(box.getAttribute('data-units')) || 1;
    var items = [];
    if (addonOn() && addonId) {
      if (mode === 'variant') {
        // The bivy rides on one radio: that radio is the "with bivy" variant.
        items.push({ id: addonId, quantity: 1 });
        if (units > 1) items.push({ id: baseId, quantity: units - 1 });
      } else {
        items.push({ id: baseId, quantity: units });
        items.push({ id: addonId, quantity: 1 });
      }
    } else {
      items.push({ id: baseId, quantity: units });
    }
    btn.classList.add('is-shine');
    setTimeout(function () { btn.classList.remove('is-shine'); }, 1200);
    if (window.OrvoAddToCart) {
      var p = window.OrvoAddToCart(items, btn);
      if (p && p.then) p.then(function () { setTimeout(paint, 1500); });
    } else {
      window.location.href = (((window.Orvo || {}).routes || {}).cart_url) || '/cart';
    }
  });

  paint();
})();
